import React from 'react';
import './Ye2.css';
import Footer from '../Footer/Footer';

function Ye2() {
  return (
    <div className='day1'>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH KIPPRA ANNUAL REGIONAL CONFERENCE  </h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
        <h1 className='prog_header_theme'>KENYA</h1>
        <h1 className='prog_header_kippra'> YOUTH SIDE EVENT PROGRAMME  </h1>
      </div>
      <div>
      
        <table>
        <p style={{fontWeight: "bold"}}>Day 2</p>
          <thead>
            <tr>
              <th style={{ fontWeight: '600', textDecoration: 'none' }} colSpan="3">Thursday: 22ND JUNE 2023</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th style={{ fontWeight: 'bold', textDecoration: 'none', backgroundColor: "white", color: "black" }} colSpan="3">THEME 3: YOUTH AGENDA IN ASAL AREAS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold" }}>8.30 - 9.00</td>
             <td></td>
              <td>Arrival and Registration  <br /> <br />
              Entertainment <br />
                </td>
            </tr>
            <tr>
              <td >9.00 - 9.15</td>
              <td > </td>
              <td >Prayer and recap of Day 1 and resolutions</td> {/* New empty column */}
            </tr>
            <tr>
              <td  >9.15 - 13.00</td>
              <td >  </td>
              <td style={{ fontWeight: "bold" }}>Main workshop – Official opening <br /> </td> {/* New empty column */}
            </tr>
            <tr>
              <td >13.00 - 14.00</td>
              <td > </td>
              <td style={{ fontWeight: "bold" }}>LUNCH BREAK </td> {/* New empty column */}
            </tr>
            <tr>
              <td >14.00 – 15.00</td>
              <td > </td>
              <td style={{ fontWeight: "bold" }}>Youth empowerment and promotion of community development <br /> <span style={{fontWeight: "normal"}}>•	Promoting talent. Self-brand and community development in ASAL</span>
              <br /> <span style={{fontWeight: "normal"}}>•	Making the difference in the community</span>
              <br /> <br />
              <span style={{fontWeight: "normal"}}>Plenary – Experience in community promotion</span> </td> {/* New empty column */}
            </tr>
            <tr>
              <td >15:00 – 16:00</td>
              <td ></td>
              <td style={{ fontWeight: "bold" }}> Youth and Public Policy Making Process <br /> <span style={{fontWeight: "normal"}}>
              •	The role of youth in Public Policy Making  <br /> <br /> Plenary – Experiences and lessons learnt </span>   </td> {/* New empty column */}
            </tr>
            <tr>
              <td >16:00 – 17:30</td>
              <td ></td>
              <td style={{ fontWeight: "bold" }}> Youth Debate <br /> <span style={{fontWeight: "normal"}}>
              Kenyan youth have potential for socioeconomic transformation of ASAL to <br />
              region of accelerated development and improved welfare.
              </span>   </td> {/* New empty column */}
            </tr>
            <tr>
              <td >17:30</td>
              <td ></td>
              <td style={{ fontWeight: "normal" }}> Refreshment and Departure (End of Day 2)</td> {/* New empty column */}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </div>
  )
}

export default Ye2;
